export const queryKeys = {
  ORGANIZATION_STATISTICS: "organization-statistics",
}